class BundleProducts extends HHBaseElement {
  constructor() {
    super()

    this._handleVariantChange = this._handleVariantChange.bind(this)
    this._handleAddToCart = this._handleAddToCart.bind(this)

    const variantsScript = this.querySelector('[data-bundle-variants]')

    this.bundleType = this.getAttribute('data-bundle-type') || 'custom'
    this.bundleId = this.getAttribute('data-bundle-product-id')
    this.bundleVariantId = this.getAttribute('data-bundle-variant-id')
    this.$addToCartButton = document.querySelector(this.getAttribute('data-add-to-cart-selector'))

    this._updateButtonState()
    this._attachListeners()
  }

  _handleVariantChange(event) {
    if (!this.contains(event.target) || !event.target.matches('[data-variant-selector]')) {
      return
    }

    const input = event.target
    const variantId = input.dataset.variantId
    const wrapper = input.closest('.bundle-product-wrapper')
    if (wrapper) {
      const dynamicSection = wrapper.querySelector('dynamic-section')
      dynamicSection.setAttribute('params', `?variant=${variantId}`)
      if (input.checked) {
        wrapper.setAttribute('data-selected-variant', variantId)
      }
    }

    this._updateButtonState()
  }

  async _handleAddToCart(event) {
    event.preventDefault()

    if (this.$addToCartButton.disabled) {
      return
    }

    const items = []

    if (this.bundleType === "fixed") {
      items.push({
        id: this.bundleVariantId,
        quantity: 1,
      })
    } else {
      const uniqueId =
        (crypto.randomUUID && crypto.randomUUID()) ||
        `${Date.now()}_${Math.floor(Math.random() * 10000)}`
      const wrappers = [...this.querySelectorAll('.bundle-product-wrapper')]
      const variantIds = wrappers.map(wrapper => wrapper.getAttribute('data-selected-variant')).filter(i => !!i);
      const properties = {
        _parent_variant_id: this.bundleVariantId,
        _bundle_id: uniqueId,
      }
      items.push(...variantIds.map(id => ({ id, quantity: 1, properties })));
    }

    try {
      await window.__CART__CONTROLLER__.add(items, false)
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'))

      this._updateButtonState()
    } catch (error) {
      console.error('Error adding bundle to cart:', error)
    }
  }

  _updateButtonState(state = false, unavailable = false) {
    this.$addToCartButton.disabled = state
    if (unavailable) {
      this.$addToCartButton.classList.add('out-of-stock');
    } else {
      this.$addToCartButton.classList.remove('out-of-stock');
    }
  }

  connectedCallback() {
    this._attachListeners()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _attachListeners() {
    this.addEventListener('dynamic-section::loaded', this._validateProducts)
    this.$addToCartButton.addEventListener('click', this._handleAddToCart)

    const wrappers = this.querySelectorAll('.bundle-product-wrapper')
    wrappers.forEach(wrapper => {
      wrapper.addEventListener('change', this._handleVariantChange, true)
    })
  }

  _validateProducts() {
    const disabledVariant = this.querySelector('[data-unavailable="true"]')
    if (disabledVariant) {
      this._updateButtonState(true, true);
    } else {
      this._updateButtonState(false);
    }
  }

  _removeListeners() {
    this.$addToCartButton.removeEventListener('click', this._handleAddToCart)

    const wrappers = this.querySelectorAll('.bundle-product-wrapper')
    wrappers.forEach(wrapper => {
      wrapper.removeEventListener('change', this._handleVariantChange, true)
    })
  }
}

window.customElements.define('bundle-products', BundleProducts)
